import { render } from "./SmsCommunication.vue?vue&type=template&id=07a641b0&scoped=true"
import script from "./SmsCommunication.vue?vue&type=script&lang=js"
export * from "./SmsCommunication.vue?vue&type=script&lang=js"

import "./SmsCommunication.vue?vue&type=style&index=0&id=07a641b0&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07a641b0"]])

export default __exports__